import { useEffect, useRef, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { useSite } from '../../context/SiteContext';
import { SolutionSectionView } from './SolutionSectionView';

// Onboarding Screenshots
import searchImg from '../../assets/onbaording/search.jpg';
import downloadImg from '../../assets/onbaording/downlaod.jpg';
import createImg from '../../assets/onbaording/create.jpg';
import transactImg from '../../assets/onbaording/transact.jpg';
import referImg from '../../assets/onbaording/refer.jpg';
//   {
//     title: 'Fill in your details and verify your phone number',
//     description:
//       'Provide your email and phone number and verify your phone number with an OTP.',
//     mockup: Step1Img,
//   },
//   {
//     title: 'Get verified',
//     description:
//       'Select username & password. Provide your BVN and KYC details and start face & ID verification. You can then set up a PIN for managing your account.',
//     mockup: Step2Img,
//   },
//   {
//     title: 'Fund your accounts',
//     description:
//       'Click on "add money" to find your account details, and top up to start making transfers',
//     mockup: Step3Img,
//   },
//   {
//     title: "You're done!",
//     description: 'Click on the Card menu to order a card and get it in 48hrs.',
//     mockup: Step4Img,
//   },
// ];



export default function SolutionSection() {
  const { howItWorks, loading } = useSite();
  const [activeStep, setActiveStep] = useState(0);
  const sectionRef = useRef(null);

  const defaultSteps = [
    {
      title: 'Find WayaBank',
      description: "Search 'WayaBank' on Google, the App Store, or Google Play. You are already in the right place.",
      mockup: searchImg,
    },
    {
      title: 'Download the App',
      description: 'Available on Android and iOS. Download in seconds and open the app to begin.',
      mockup: downloadImg,
    },
    {
      title: 'Create Your Account',
      description: "Sign up with your phone number or email and verify your identity for a secure banking experience.",
      mockup: createImg,
    },
    {
      title: 'Start Transacting',
      description: 'Send money, pay bills, request loans, and manage your finances from the very first day.',
      mockup: transactImg,
    },
    {
      title: 'Refer & Earn',
      description: 'Every friend you bring to WayaBank puts something back in your pocket. Share the link, earn the reward.',
      mockup: referImg,
    },
  ];

  // Determine steps from context or fallbacks
  const steps =
    howItWorks && Array.isArray(howItWorks.steps) && howItWorks.steps.length > 0
      ? howItWorks.steps.map((step, idx) => ({
          ...step,
          // Force local high-quality mockups by index
          mockup: defaultSteps[idx]?.mockup || step.image_url
        }))
      : defaultSteps;

  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current || loading) return;

      const rect = sectionRef.current.getBoundingClientRect();
      const sectionHeight = rect.height;
      const viewportHeight = window.innerHeight;

      const scrollPos = -rect.top;
      const scrollMax = sectionHeight - viewportHeight;
      const scrollPercent = Math.max(0, Math.min(1, scrollPos / scrollMax));

      // Calculate active step based on scroll percentage
      const floatStep = scrollPercent * (steps.length - 1);
      const current = Math.round(floatStep);

      if (current !== activeStep) {
        setActiveStep(current);
      }
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll();

    return () => window.removeEventListener('scroll', handleScroll);
  }, [loading, steps.length, activeStep]);

  if (loading) {
    return (
      <section className="waya-works-wrapper py-5">
        <div className="container">
          <div className="row">
            <div className="col-md-6">
              <Skeleton height={400} className="rounded-24" />
            </div>
            <div className="col-md-6 d-flex flex-column justify-content-center">
              <Skeleton width="30%" height={20} className="mb-3" />
              <Skeleton width="80%" height={40} className="mb-4" />
              <Skeleton count={3} />
            </div>
          </div>
        </div>
      </section>
    );
  }

  // Guard against negative numbers if the array is empty
  const safeActiveStep = Math.max(
    0,
    Math.min(activeStep, steps.length - 1)
  );

  return (
    <div className="waya-works-pin-container" ref={sectionRef}>
      <div className="waya-works-sticky-wrapper">
        <SolutionSectionView
          activeStep={safeActiveStep}
          steps={steps}
          current={steps[safeActiveStep]?.mockup || steps[safeActiveStep]?.image_url}
        />
      </div>
    </div>
  );
}
